<template>
  <v-text-field
    v-model="newValue"
    :color="activeWarning ? 'error' : 'info'"
    background-color="secondary"
    :type="field.type === 'Number' ? 'number' : 'text'"
    :label="field.label"
    :hint="field.helpText"
    :persistent-hint="field.alwaysVisibleHelpText"
    :readonly="field.readonly"
    :rules="field.rules"
    :class="{ 'field-warning': activeWarning }"
    :messages="activeWarning ? activeWarning.message : []"
  />
</template>

<script setup>
import { computed, ref, watch } from 'vue';

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({
  field: { type: Object, default: () => { } },
  value: { type: [Number, String], default: null }
});

const newValue = ref(props.value);

// Checkers receive the current field value and the warning config, and return whether the warning is triggered
const warningTypes = {
  maxLength: (value, warning) => typeof value === 'string' && value.length > warning.value,
};

// `messages` (unlike `errorMessages`) does not mark the field as invalid or block form submission
const activeWarning = computed(() => {
  if (!Array.isArray(props.field.warnings)) return null;

  return props.field.warnings
    .find(warning => warningTypes[warning.type]?.(newValue.value, warning)) || null;
});

watch(() => props.value, value => {
  newValue.value = value;
});

watch(newValue, value => {
  emit('input', value === '' ? null : value);
});
</script>

<style lang="scss" scoped>
.field-warning {
  ::v-deep .v-messages__message {
    color: #ff5252;
  }

  ::v-deep .v-input__slot {
    color: #ff5252;
    border: 2px solid #ff5252;
  }

  ::v-deep .v-label {
    color: #ff5252;
  }
}
</style>
